import { msalInstance, apiRequest } from '~/util/msalConfig';

/**
 * Acquires an access token silently, refreshing if necessary.
 * MSAL handles its own in-memory and localStorage cache internally —
 * acquireTokenSilent returns cached tokens when valid and only hits the
 * network when a refresh is needed.
 */
export const acquireMsalAccessToken = async (): Promise<string> => {
	const account = msalInstance.getActiveAccount();
	if (!account) {
		throw new Error('No active account! Please sign in.');
	}

	const response = await msalInstance.acquireTokenSilent({
		...apiRequest,
		account: account
	});
	return response.accessToken;
};

/**
 * Clears all MSAL accounts and tokens from cache so the login page can
 * properly initiate a fresh login redirect.
 */
export const clearMsalAccounts = async () => {
	await msalInstance.clearCache();
};

/**
 * Gets the user's email from the active account
 */
export const getMsalEmail = (): string | null => {
	const account = msalInstance.getActiveAccount();
	if (account?.username) {
		return account.username;
	} else if (account?.idTokenClaims && account.idTokenClaims['email']) {
		return account.idTokenClaims['email'] as string;
	}

	return null;
};
